import Spinner from 'react-bootstrap/Spinner';

interface IOwnProps {
 inline?: boolean;
}

function Loader(props: IOwnProps) {
  return (
    <div className={`${!props.inline ?'position-fixed h-100 bg-black bg-opacity-10 ' :''}w-100 d-flex justify-content-center align-items-center p-5`} style={{ zIndex: 9999}}>
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    </div>
  );
}

export default Loader;